import commonConfig from "../../config/common";
import { useSelector } from "react-redux";
import { getStoreCode } from "../../state/modules/config/selectors";

export const useConfigByStore = ({ configKey }) => {
  const key = commonConfig[configKey];

  if (!key) {
    return null;
  }

  const storeCode = useSelector(getStoreCode);

  return key.includes(storeCode);
};
